<template>
  <div>
    <div
      v-if="$vuetify.breakpoint.mdAndUp"
      :class="['floating-right ng-float', { 'is-open': showRewardPanel }]"
      @click="setShowContactUsPanel()"
      @mouseleave="hoverContactUsPanel(false)"
      @focusout="hideShowContactUsPanel()"
      tabindex="0"
    >
      <div v-if="showRewardPanel" class="contactUs-panel ng-float-panel" @click.stop>
        <div class="ng-float-panel-head">
          <img class="contactUs-header-icon" src="/static/svg/layout/customer-support.svg" width="40" height="40" alt="" />
          <span class="ng-float-panel-title">{{ $t(`floating.contactUsHeader`) }}</span>
        </div>
        <div class="ng-contact-list">
          <a href="javascript:void(0);" @click="showIntercomLC" rel="nofollow" class="contactUs-item ng-contact-item">
            <span class="ng-contact-icon ng-contact-icon--chat"><v-icon size="20" color="#ffffff">mdi-chat-processing-outline</v-icon></span>
            <span class="ng-contact-text">
              {{ $t(`label.liveChat`) }}
              <small>24/7</small>
            </span>
            <v-icon size="18" color="#9DA1C0">mdi-chevron-right</v-icon>
          </a>
          <a href="https://t.me/nagad88official" target="_blank" rel="nofollow" class="contactUs-item ng-contact-item">
            <span class="ng-contact-icon ng-contact-icon--telegram"><v-icon size="20" color="#ffffff">mdi-telegram</v-icon></span>
            <span class="ng-contact-text">
              Telegram
              <small>@nagad88official</small>
            </span>
            <v-icon size="18" color="#9DA1C0">mdi-chevron-right</v-icon>
          </a>
          <a href="mailto:support@nagad88.com" rel="nofollow" target="_blank" class="contactUs-item ng-contact-item">
            <span class="ng-contact-icon ng-contact-icon--email"><v-icon size="20" color="#ffffff">mdi-email-outline</v-icon></span>
            <span class="ng-contact-text">
              Email
              <small>support@nagad88.com</small>
            </span>
            <v-icon size="18" color="#9DA1C0">mdi-chevron-right</v-icon>
          </a>
        </div>
      </div>
      <button type="button" @mouseenter="hoverContactUsPanel(true)" class="floating-button ng-float-tab ng-float-tab--contact" :aria-label="$t(`label.contactUs`)" :aria-expanded="showRewardPanel ? 'true' : 'false'">
        <v-icon class="ng-float-tab-icon" color="#ffffff">mdi-headset</v-icon>
        <span class="ng-float-tab-label">{{ $t(`label.contactUs`) }}</span>
      </button>
    </div>

    <div v-if="$vuetify.breakpoint.smAndDown" class="fab-contactUs ng-fab-contact">
      <div v-if="moreContactUs" class="ng-fab-list">
        <a href="javascript:void(0);" @click="showIntercomLC" rel="nofollow" class="ng-fab-item">
          <span class="ng-fab-label">{{ $t(`label.liveChat`) }}</span>
          <span class="ng-contact-icon ng-contact-icon--chat"><v-icon size="20" color="#ffffff">mdi-chat-processing-outline</v-icon></span>
        </a>
        <a href="https://t.me/nagad88official" rel="nofollow" target="_blank" class="ng-fab-item">
          <span class="ng-fab-label">Telegram</span>
          <span class="ng-contact-icon ng-contact-icon--telegram"><v-icon size="20" color="#ffffff">mdi-telegram</v-icon></span>
        </a>
        <a href="mailto:support@nagad88.com" rel="nofollow" target="_blank" class="ng-fab-item">
          <span class="ng-fab-label">Email</span>
          <span class="ng-contact-icon ng-contact-icon--email"><v-icon size="20" color="#ffffff">mdi-email-outline</v-icon></span>
        </a>
      </div>
      <button type="button" @click="setMoreContactUs()" class="ng-fab-main" :aria-label="$t(`label.contactUs`)" :aria-expanded="moreContactUs ? 'true' : 'false'">
        <v-icon size="26" color="#ffffff">{{ moreContactUs ? 'mdi-close' : 'mdi-chat-processing-outline' }}</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
import { uiHelper, locale } from '@/util'
import i18n from '@/plugins/i18n'
import { ROUTE_NAME } from '@/constants/route.constants'
import { DevicePlatform } from '@/constants/enums'

export default {
  name: 'floatingContactUs',
  props: {},
  data: () => ({
    i18n,
    showRewardPanel: false,
    active: false,
    moreContactUs: false,
    showButton: true
  }),
  methods: {
    showIntercomLC() {
      Intercom('show')
      return false
    },
    // Hover opens on enter and closes on leave (unless pinned by a click), instead of toggling
    hoverContactUsPanel(open) {
      if (!this.active) this.showRewardPanel = open
    },
    setShowContactUsPanel() {
      if (!this.active && this.showRewardPanel) {
        this.active = true
        this.showRewardPanel = true
      } else {
        this.active = !this.active
        this.showRewardPanel = !this.showRewardPanel
      }
    },
    hideShowContactUsPanel() {
      this.active = false
      this.showRewardPanel = false
    },
    setMoreContactUs() {
      this.moreContactUs = !this.moreContactUs
    },
    openLiveChat() {
      this.$parent.openLiveChat()
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      let lvlwrapper = document.getElementsByClassName('vipwrapper')[0]
      if (lvlwrapper) {
        lvlwrapper.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    }
  }
}
</script>

<style lang="scss">
// Shared .ng-float / .ng-float-tab / .ng-float-panel styles live in FloatingReward.vue
.floating-right.ng-float {
  right: 0;
  z-index: 5;
}

.ng-float-tab--contact {
  border-radius: 14px 0 0 14px;
  background: var(--ng-gradient-brand);
  color: #ffffff !important;

  .ng-float-tab-label {
    color: #ffffff !important;
  }

  &:hover {
    padding-right: 12px;
  }
}

.ng-contact-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ng-contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 52px;
  padding: 8px 10px;
  border-radius: 12px;
  text-decoration: none;
  color: var(--ng-text) !important;
  transition: background 0.15s ease-out;

  &:hover,
  &:focus-visible {
    background: #f3f4fa;
  }
}

.ng-contact-text {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  font-family: var(--ng-font-bold);
  font-size: 14px;
  line-height: 1.3;

  small {
    font-family: var(--ng-font);
    font-size: 12px;
    color: var(--ng-text-muted);
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.ng-contact-icon {
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  &--chat {
    background: var(--ng-gradient-cta);
  }

  &--telegram {
    background: linear-gradient(180deg, #45b4e4, #0092c8);
  }

  &--email {
    background: linear-gradient(180deg, #70c59e, #368f6b);
  }
}

// ---------- Mobile floating chat button ----------
.fab-contactUs.ng-fab-contact {
  position: fixed;
  right: 14px;
  bottom: 84px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.ng-fab-main {
  width: 52px;
  height: 52px;
  border: 3px solid #ffffff;
  border-radius: 999px;
  background: var(--ng-gradient-brand);
  box-shadow: 0 6px 16px rgba(18, 23, 52, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.ng-fab-list {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  animation: ngFloatIn 0.2s ease-out;
}

.ng-fab-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 4px;
  text-decoration: none;

  .ng-fab-label {
    padding: 6px 10px;
    border-radius: 999px;
    background: #ffffff;
    color: var(--ng-text);
    font-family: var(--ng-font-bold);
    font-size: 12px;
    box-shadow: 0 2px 8px rgba(18, 23, 52, 0.2);
  }

  .ng-contact-icon {
    width: 44px;
    height: 44px;
    border-radius: 999px;
    box-shadow: 0 4px 10px rgba(18, 23, 52, 0.25);
  }
}
</style>
